/* KrakenTheMeta dashboard — shell: auth boot, user chrome, free-build meter, notifications,
 * checkout, and the homepage hand-off. Shared UI bits (deck tiles, the Pro pitch) live here too.
 */
(function () {
  "use strict";

  var KD = window.KD, S = KD.state, D = KD.data, esc = KD.esc;

  // ---------------------------------------------------------------- user chrome
  KD.paintUser = function () {
    KD.$$("[data-avatar]").forEach(function (img) { img.src = KD.avatar(S.user.avatar); });
    KD.$$("[data-username]").forEach(function (el) { el.textContent = S.user.displayName; });
    KD.paintGens();
  };

  KD.paintGens = function () {
    var g = D.gens();
    KD.$$("[data-gens]").forEach(function (el) {
      var chip = el.classList.contains("gens--chip");
      el.classList.toggle("is-out", !g.unlimited && g.left <= 0);
      if (g.unlimited) {
        el.innerHTML = chip
          ? KD.icon("sparkle") + "<span>Unlimited</span>"
          : '<div class="gens__label"><span>AI builds</span><span>' + (S.isPro ? "Kraken Pro" : "Supporter") + '</span></div><div class="gens__num">∞<small>unlimited</small></div>';
        el.title = "Unlimited AI deck builds";
        return;
      }
      var out = g.left <= 0;
      el.title = "Free AI deck builds left this week";
      if (chip) { el.innerHTML = KD.icon("sparkle") + "<span>" + (out ? "0 builds" : g.left + " " + KD.plural(g.left, "build")) + "</span>"; return; }
      el.innerHTML = '<div class="gens__label"><span>Free AI builds</span><span>this week</span></div>' +
        '<div class="gens__num">' + g.left + "<small>left</small></div>" +
        '<div class="gens__meter"><i style="width:' + Math.min(100, g.left * 100) + '%"></i></div>' +
        '<p class="gens__note">' + (out ? esc((D.nextResetText(g) || "refills weekly").replace(/^./, function (c) { return c.toUpperCase(); })) : "Refills every week") + ' · <button type="button" data-checkout="pro">Go unlimited</button></p>';
    });
  };

  // ---------------------------------------------------------------- shared pieces

  // A deck tile: the deck's commander/key card art, its name, format and size.
  KD.deckCard = function (d, publicId) {
    var art = d.headerImage ? '<img src="' + esc(KD.safeUrl(D.artUrl(d.headerImage))) + '" alt="" loading="lazy" decoding="async">'
      : '<span class="mark"><svg viewBox="0 0 64 64" aria-hidden="true"><use href="#mark"/></svg></span>';
    var status = publicId ? '<span class="badge badge--glow">' + KD.icon("globe") + "Public</span>" : "";
    var count = d.cardCount == null ? "…" : d.cardCount;
    return '<a class="dcard" href="#/deck/' + encodeURIComponent(d.id) + '" data-deck="' + esc(d.id) + '">' +
      '<div class="dcard__art">' + art + '<div class="dcard__badges"><span class="badge">' + esc(D.formatLabel(d.format)) + "</span>" + status + "</div></div>" +
      '<div class="dcard__body"><h3 class="dcard__name">' + esc(d.name || "Untitled deck") + "</h3>" +
      '<div class="dcard__meta"><span>' + count + " / " + D.targetSize(d.format) + " cards</span>" + KD.icon("right") + "</div></div></a>";
  };
  KD.deckSkeletons = function (n) {
    var h = "";
    for (var i = 0; i < n; i++) h += '<div class="dcard dcard--skel skel" aria-hidden="true"></div>';
    return h;
  };

  // The Kraken Pro card: free users get the pitch, members get the receipt.
  KD.proCard = function () {
    if (S.isPro) {
      return '<div class="procard procard--on"><h3>Kraken Pro <span class="badge badge--glow">Active</span></h3>' +
        "<p>Unlimited AI deck builds, all three coaching modes and 750 coach messages a month in MTG Arena.</p>" +
        '<button class="btn btn--ghost btn--block mt-16" type="button" data-go="profile">' + KD.icon("card") + "Plan &amp; billing</button></div>";
    }
    if (S.isLegacyPatron) {
      return '<div class="procard"><h3>Early supporter <span class="badge badge--gold">Unlimited</span></h3>' +
        "<p>You have unlimited AI deck builds. Thank you for backing the Kraken early.</p>" +
        "<p>As a thank-you you can unlock the MTG Arena Assistant's Pro features for free.</p>" +
        '<button class="btn btn--gold btn--block mt-16" type="button" data-go="profile">Claim free Assistant Pro</button></div>';
    }
    var g = D.gens();
    return '<div class="procard"><h3>Kraken Pro <span class="badge badge--gold">$4.99/mo</span></h3>' +
      "<p>" + (g.left > 0 ? "You have " + g.left + " free AI " + KD.plural(g.left, "build") + " left this week." : "You've used this week's free AI build.") + "</p>" +
      "<ul>" +
      "<li>" + KD.icon("check") + "<span><b>Unlimited</b> AI deck builds</span></li>" +
      "<li>" + KD.icon("check") + "<span>An AI coach on every turn in MTG Arena</span></li>" +
      "<li>" + KD.icon("check") + "<span>Match history and replays on your profile</span></li>" +
      "<li>" + KD.icon("check") + "<span>The whole site ad-free</span></li>" +
      "</ul>" +
      '<button class="btn btn--gold btn--block" type="button" data-checkout="pro">Upgrade to Pro</button>' +
      "<small>Cancel anytime · the Arena coach is free for your first 3 matches</small></div>";
  };

  // Out of free builds: the Pro pitch, right where they were trying to build.
  KD.upsell = function (serverMsg) {
    var reset = serverMsg && /resets in [^.]+/i.exec(serverMsg);
    var g = D.gens();
    KD.ga("gen_upsell_shown");
    KD.sheet({
      title: "You've used this week's free build",
      body: '<div class="upsell"><h3>Go unlimited with Kraken Pro</h3>' +
        "<p>Free accounts get one AI deck a week" + (reset ? " (" + esc(reset[0]) + ")" : g.next ? " (" + esc(D.nextResetText(g)) + ")" : "") + ". Pro removes the limit and adds the MTG Arena coach.</p>" +
        "<ul>" +
        "<li>" + KD.icon("check") + "<span><b>Unlimited</b> AI deck builds</span></li>" +
        "<li>" + KD.icon("check") + "<span>An AI coach on every turn in MTG Arena (750 messages a month)</span></li>" +
        "<li>" + KD.icon("check") + "<span>Match history and per-deck records on your profile</span></li>" +
        "<li>" + KD.icon("check") + "<span>Browse the whole site ad-free</span></li>" +
        "</ul>" +
        '<button class="btn btn--gold btn--lg btn--block" type="button" data-checkout="pro">Go Pro — $4.99/mo</button>' +
        '<p class="hint">Cancel anytime. Your free build refills every week either way.</p></div>'
    });
  };

  KD.proWelcome = function () {
    try { if (localStorage.getItem("kd_pro_welcomed")) return; localStorage.setItem("kd_pro_welcomed", String(Date.now())); } catch (e) { /* show it anyway */ }
    KD.ga("pro_welcome_shown");
    var s = KD.sheet({
      title: "Welcome to Kraken Pro",
      sub: "Unlimited AI builds and upgrades, and the coach in MTG Arena. Where do you want to start?",
      body: '<div class="ways welcome">' +
        '<button type="button" class="is-primary" data-welcome="build"><span class="ico">' + KD.icon("sparkle") + "</span><span><b>Build a deck with AI</b><small>Describe it, pick a format, and the Kraken builds the whole list.</small></span></button>" +
        '<button type="button" data-welcome="improve"><span class="ico">' + KD.icon("wand") + "</span><span><b>Improve a deck I have</b><small>Paste your list and pick from swaps for the weakest cards.</small></span></button>" +
        '<a href="' + KD.SITE + '/arena-assistant" target="_blank" rel="noopener"><span class="ico">' + KD.icon("desktop") + "</span><span><b>Set up the Arena coach</b><small>Install the free Windows app, sign in, and it coaches every turn.</small></span></a>" +
        "</div>"
    });
    KD.$$("[data-welcome]", s.el).forEach(function (b) {
      b.addEventListener("click", function () {
        s.close();
        KD.ga("pro_welcome_pick", { pick: b.dataset.welcome });
        if (b.dataset.welcome === "build") KD.create.open({ mode: "ai" });
        else KD.create.open({ mode: "import" });
      });
    });
  };

  // ---------------------------------------------------------------- checkout (Stripe)
  var checkingOut = false;
  KD.checkout = async function (kind, btn) {
    if (checkingOut) return;
    checkingOut = true;
    var orig = btn ? btn.innerHTML : "";
    if (btn) { btn.disabled = true; btn.textContent = "Opening secure checkout…"; }
    KD.ga("checkout_start", { kind: kind });
    try {
      var r = await D.callFn("createCheckoutSession", { kind: kind });
      if (r.data.url) { location.href = r.data.url; return; }
      if (r.data.already === "pro") {
        KD.toast("You're already on Kraken Pro.", "info");
        await D.loadProfile(); KD.paintGens();
        KD.go("profile");
      } else KD.toast(r.data.error || "Could not start checkout.", "err");
    } catch (e) { KD.toast("Could not start checkout.", "err"); }
    if (btn) { btn.disabled = false; btn.innerHTML = orig; }
    checkingOut = false;
  };

  function handleReturnParams() {
    var q = new URLSearchParams(location.search);
    var clean = function () { history.replaceState(null, "", location.pathname + location.hash); };
    if (q.get("checkout") === "success") {
      clean();
      KD.toast("Payment received. Your plan updates in a few seconds.", "ok");
      KD.go("profile");
      // 2026-10-03: the first hour decides whether Pro sticks (most cancellations happen the same
      // day), so a new member gets two clear next steps instead of a billing page
      var tries = 0;
      var check = function () {
        D.loadProfile().then(function () {
          KD.paintGens();
          if (KD.parseRoute().name === "profile") KD.router();
          if (S.isPro) KD.proWelcome();
          else if (++tries < 4) setTimeout(check, 2500);
        }).catch(function () { /* the plan shows on the next load */ });
      };
      setTimeout(check, 2500);
      return true;
    }
    if (q.get("checkout") === "cancel") { clean(); KD.toast("Checkout cancelled. You weren't charged.", "info"); return false; }
    var buy = q.get("buy");
    if (["pro", "tok250", "tok750"].indexOf(buy) !== -1) {
      clean();
      KD.go("profile");
      setTimeout(function () { KD.checkout(buy, null); }, 400);
      return true;
    }
    // a signed-out visitor who clicked a buy link was sent through sign-in; resume their checkout
    var stash = null;
    try { stash = localStorage.getItem("kd_buy_intent"); localStorage.removeItem("kd_buy_intent"); } catch (e) { /* storage blocked */ }
    if (["pro", "tok250", "tok750"].indexOf(stash) !== -1) {
      KD.go("profile");
      setTimeout(function () { KD.checkout(stash, null); }, 400);
      return true;
    }
    return false;
  }

  // ---------------------------------------------------------------- homepage hand-off
  // The homepage's "describe your deck" box stores {prompt, format, at} and sends the visitor through
  // sign-in. Pick it up once and open the AI builder with the idea typed in.
  function resumePending() {
    var formats = D.FORMATS.map(function (f) { return f[0]; });
    // 2026-10-03: "Fix the gaps with AI" (analyzer) and "Upgrade it with AI" (precons) send the real
    // list: it becomes the player's deck and opens straight into Improve with the goal filled in
    var up = null;
    try { up = JSON.parse(localStorage.getItem("ktm_pending_upgrade") || "null"); localStorage.removeItem("ktm_pending_upgrade"); } catch (e) { up = null; }
    if (up && typeof up.list === "string" && up.list.trim() && up.at && Date.now() - up.at < 3 * 864e5) {
      var parsedUp = D.parseListText(up.list.slice(0, 20000));
      if (parsedUp.entries.length) {
        var fmtUp = formats.indexOf(up.format) !== -1 ? up.format : "commander";
        KD.busy("Setting up your deck…");
        D.createDeck(String(up.name || "My deck").slice(0, 80), fmtUp).then(function (d) {
          KD.idle();
          KD.builder.pendingImport = parsedUp;
          KD.builder.improvePreset = { goal: String(up.goal || "").slice(0, 400), goals: Array.isArray(up.goals) ? up.goals.slice(0, 3) : null };
          KD.ga("dashboard_upgrade_resumed", { from: up.from || "" });
          KD.go("deck/" + d.id);
        }).catch(function () { KD.idle(); KD.toast("Couldn't create the deck. Paste your list with Import instead.", "err"); });
        return;
      }
    }
    // "Copy to my decks" on a public deck page stores the list; it opens here as a ready-to-go import
    var imp = null;
    try { imp = JSON.parse(localStorage.getItem("ktm_pending_import") || "null"); localStorage.removeItem("ktm_pending_import"); } catch (e) { imp = null; }
    if (imp && typeof imp.list === "string" && imp.list.trim() && imp.at && Date.now() - imp.at < 3 * 864e5) {
      KD.create.open({ mode: "import", name: String(imp.name || "Imported deck").slice(0, 80), format: formats.indexOf(imp.format) !== -1 ? imp.format : "commander", list: imp.list.slice(0, 20000), fromDeckView: true });
      KD.ga("dashboard_import_resumed", { from: imp.from || "" });
      return;
    }
    var p = null;
    try { p = JSON.parse(localStorage.getItem("ktm_pending_deck") || "null"); localStorage.removeItem("ktm_pending_deck"); } catch (e) { return; }
    if (!p || typeof p.prompt !== "string" || !p.prompt.trim() || !p.at || Date.now() - p.at > 3 * 864e5) return;
    KD.create.open({ mode: "ai", prompt: p.prompt.trim().slice(0, 300), format: formats.indexOf(p.format) !== -1 ? p.format : "commander", fromLanding: true });
    KD.ga("dashboard_prompt_resumed", { format: p.format });
  }

  // ---------------------------------------------------------------- notifications bell
  KD.bell = {
    list: [],
    start: function () {
      var self = this;
      var toggle = KD.$("[data-bell-toggle]"), panel = KD.$("[data-bell-panel]");
      if (!toggle) return;
      D.notifications.listen(function (list) { self.list = list; self.paint(); });
      self.paint();
      toggle.addEventListener("click", function (e) {
        e.stopPropagation();
        var open = panel.hidden;
        panel.hidden = !open;
        toggle.setAttribute("aria-expanded", String(open));
        if (open) { self.paint(); if (self.list.some(function (n) { return !n.viewed; })) D.notifications.markRead(); }
      });
      document.addEventListener("click", function (e) {
        if (!panel.hidden && !panel.contains(e.target) && !toggle.contains(e.target)) { panel.hidden = true; toggle.setAttribute("aria-expanded", "false"); }
      });
      KD.$("[data-bell-clear]").addEventListener("click", async function () {
        try { await D.notifications.clear(); self.list = []; self.paint(); }
        catch (e) { KD.toast("Couldn't clear notifications.", "err"); }
      });
    },
    paint: function () {
      var unread = this.list.filter(function (n) { return !n.viewed; }).length;
      var badge = KD.$("[data-bell-count]");
      if (badge) { badge.hidden = !unread; badge.textContent = unread > 9 ? "9+" : String(unread); }
      var ul = KD.$("[data-bell-list]");
      if (!ul) return;
      if (!this.list.length) { ul.innerHTML = '<li class="bell__empty">Nothing yet. Mentions and new followers show up here.</li>'; return; }
      ul.innerHTML = this.list.slice(0, 40).map(function (n) {
        var msg = String(n.message || "");
        var plain = msg.replace(/^"(.*)"$/, "$1"); // older like notifications were stored wrapped in quotes
        var text = /is now following you| liked '/.test(plain) ? plain : (n.taggerName || "Someone") + " tagged you: “" + msg + "”";
        var when = n.timestamp ? KD.ago(new Date(n.timestamp)) : "";
        return '<li class="' + (n.viewed ? "" : "is-new") + '">' + esc(text) + (when ? "<time>" + esc(when) + "</time>" : "") + "</li>";
      }).join("");
    }
  };

  // ---------------------------------------------------------------- delegated actions
  document.addEventListener("click", function (e) {
    var co = e.target.closest("[data-checkout]");
    if (co) { e.preventDefault(); KD.closeSheets(); KD.checkout(co.dataset.checkout, co.tagName === "BUTTON" ? co : null); return; }
    var cr = e.target.closest("[data-create]");
    if (cr) { e.preventDefault(); KD.create.open({}); return; }
    var go = e.target.closest("[data-go]");
    if (go) { e.preventDefault(); KD.closeSheets(); KD.go(go.dataset.go); }
  });

  // ---------------------------------------------------------------- boot
  function boot() {
    try { window.KTMFirebase.boot(); }
    catch (e) { console.error("firebase boot", e); KD.$("#view").innerHTML = '<div class="empty">' + KD.icon("alert") + "<h3>Couldn't connect</h3><p>Please refresh the page.</p></div>"; return; }
    firebase.auth().onAuthStateChanged(async function (user) {
      if (!user) {
        if (KD.signingOut) return; // the profile's sign-out sends people home itself
        var buy = new URLSearchParams(location.search).get("buy");
        if (["pro", "tok250", "tok750"].indexOf(buy) !== -1) try { localStorage.setItem("kd_buy_intent", buy); } catch (e) { /* ignore */ }
        location.href = KD.SITE + "/sign-in";
        return;
      }
      if (S.user && S.user.id === user.uid) return; // token refresh, not a new session
      S.user = { id: user.uid, email: user.email, displayName: user.displayName || "Planeswalker", avatar: "/images/avatar1.png" };
      try { await D.loadProfile(); }
      catch (e) { console.error("profile", e); KD.toast("Couldn't load your profile. Try refreshing.", "err"); }
      document.body.classList.remove("is-booting");
      KD.paintUser();
      // old deep links (#decks, #profile, #overview …) keep working
      var h = (location.hash || "").replace(/^#/, "");
      if (/^(overview|decks|collection|arena|profile)$/.test(h)) history.replaceState(null, "", location.pathname + location.search + "#/" + (h === "overview" ? "home" : h));
      var redirected = handleReturnParams();
      KD.router();
      KD.bell.start();
      if (!redirected) resumePending();
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
